const validateEditorState = (editorState) => {
  const result = [];

  if (!editorState.password) {
    result.push({
      param: 'password',
      userMessage: 'Pole wymagane.',
    });
  }

  if (!editorState.passwordConfirm) {
    result.push({
      param: 'passwordConfirm',
      userMessage: 'Pole wymagane.',
    });
  }

  if (editorState.password && editorState.passwordConfirm && editorState.password !== editorState.passwordConfirm) {
    result.push({
      param: 'passwordConfirm',
      userMessage: 'Pola \'Hasło\' i \'Powtórz Hasło\' muszą zawierać taką samą wartość.',
    });
  }

  return result.length > 0 ? result : null;
};

export default validateEditorState;
